export const UPKEEP_MAP_API = {
    COA_LIST: '/api/report-upkeep-coa-list',
    ACTIVITY_LIST: '/api/report-upkeep-activity-list',
    BLOCK_REPORT: '/api/report-upkeep-block-monitoring',
};

export const UPKEEP_MAP_DEFAULTS = {
    COMPANY_ID: 1,
    REVISION: 0,
};

export const MONTH_COLORS: Record<string, string> = {
    '01': '#E6194B',
    '02': '#F58231',
    '03': '#FFE119',
    '04': '#2C7BE5',
    '05': '#7B2FBE',
    '06': '#3CB44B',
    '07': '#D11FD1',
    '08': '#42D4F4',
    '09': '#FF5BA3',
    '10': '#8D5524',
    '11': '#BFEF45',
    '12': '#00B2A9',
};

export const MONTH_NAMES: Record<string, string> = {
    '01': 'Januari', '02': 'Februari', '03': 'Maret', '04': 'April',
    '05': 'Mei', '06': 'Juni', '07': 'Juli', '08': 'Agustus',
    '09': 'September', '10': 'Oktober', '11': 'November', '12': 'Desember',
};

export const MONTH_NAMES_SHORT: Record<string, string> = {
    '01': 'Jan', '02': 'Feb', '03': 'Mar', '04': 'Apr',
    '05': 'Mei', '06': 'Jun', '07': 'Jul', '08': 'Ags',
    '09': 'Sep', '10': 'Okt', '11': 'Nov', '12': 'Des',
};
